module.exports = __webpack_public_path__ + "static/media/showcase-3.c186452b.jpg";